export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/MyProfile.6d5c483e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};